"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var UsrAdminsListCtl = /** @class */ (function (_super) {
    __extends(UsrAdminsListCtl, _super);
    function UsrAdminsListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_login = UIUtils_1.UIUtils.IProp2Str(function (o) { o.login; });
        _this.dk_name = UIUtils_1.UIUtils.IProp2Str(function (o) { o.name; });
        _this.dk_surname = UIUtils_1.UIUtils.IProp2Str(function (o) { o.surname; });
        _this.dk_email = UIUtils_1.UIUtils.IProp2Str(function (o) { o.email; });
        _this.dk_phone = UIUtils_1.UIUtils.IProp2Str(function (o) { o.phone; });
        _this.dk_skype = UIUtils_1.UIUtils.IProp2Str(function (o) { o.skype; });
        _this.dk_is_locked = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_locked; });
        _this.dk_permission_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.permission_id; });
        _this.dk_permission_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.permission_title; });
        _this.dk_date_added2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added2; });
        _this.dk_date_changed2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed2; });
        _this.dk_usr_level = UIUtils_1.UIUtils.IProp2Str(function (o) { o.usr_level; });
        _this.dk_allowed_brands_count = UIUtils_1.UIUtils.IProp2Str(function (o) { o.allowed_brands_count; });
        _this.dk_is_multiaccess = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_multiaccess; });
        _this._errDialog = errDialog;
        return _this;
    }
    UsrAdminsListCtl.prototype.ResetData = function () {
        this.DATA = {
            total: 0,
            data: [],
            permissions_avail: []
        };
    };
    UsrAdminsListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        return null;
    };
    UsrAdminsListCtl.prototype.LoadData = function (onDone) {
        var _this = this;
        webAApi_1.ListAdminsGet.exec({}, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    login: resp.list[i].login,
                    name: resp.list[i].name,
                    surname: resp.list[i].surname,
                    email: resp.list[i].email,
                    phone: resp.list[i].phone,
                    skype: resp.list[i].skype,
                    is_locked: resp.list[i].locked,
                    permission_id: resp.list[i].permission_id,
                    permission_title: resp.list[i].permission_title,
                    date_changed2: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    date_added2: moment(resp.list[i].date_added_uts_ms).utc(false),
                    usr_level: resp.list[i].level,
                    allowed_brands_count: resp.list[i].allowed_brands_count,
                    is_multiaccess: resp.list[i].is_multiaccess
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    UsrAdminsListCtl.prototype.LoadAvailPermissions = function (onDone) {
        var _this = this;
        webAApi_1.ListAdminAllowedPermissionsGet.exec({}, function (resp) {
            _this.DATA.permissions_avail = [];
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.permissions_avail.push({
                    key: resp.list[i].key_uid,
                    value: resp.list[i].title,
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    UsrAdminsListCtl.prototype.AddAdmin = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddAdmin.exec({
            data: {
                login: data.login,
                password: data.password,
                name: data.name,
                surname: data.surname,
                email: data.email,
                phone: data.phone,
                skype: data.skype,
                is_locked: data.is_locked,
                admin_permission_id: data.permission_id,
                is_multiaccess: data.is_multiaccess
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                login: data.login,
                name: data.name,
                surname: data.surname,
                email: data.email,
                phone: data.phone,
                skype: data.skype,
                is_locked: data.is_locked,
                permission_id: data.permission_id,
                permission_title: data.permission_title,
                date_added2: moment(resp.date_added_uts_ms).utc(false),
                date_changed2: moment(resp.date_changed_uts_ms).utc(false),
                usr_level: resp.level,
                allowed_brands_count: 0,
                is_multiaccess: data.is_multiaccess
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    UsrAdminsListCtl.prototype.EditAdmin = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditAdmin.exec({
                data: {
                    admin_id: data.key,
                    name: data.name,
                    surname: data.surname,
                    email: data.email,
                    phone: data.phone,
                    skype: data.skype,
                    is_locked: data.is_locked,
                    admin_permission_id: data.permission_id,
                    is_multiaccess: data.is_multiaccess
                }
            }, function (resp) {
                _tmp.name = data.name;
                _tmp.surname = data.surname;
                _tmp.email = data.email;
                _tmp.phone = data.phone;
                _tmp.skype = data.skype;
                _tmp.is_locked = data.is_locked;
                _tmp.permission_id = data.permission_id;
                _tmp.permission_title = data.permission_title;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _tmp.is_multiaccess = data.is_multiaccess;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    UsrAdminsListCtl.prototype.RemoveItem = function (key) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    UsrAdminsListCtl.prototype.DeleteAdmin = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteAdmin.exec({
                data: {
                    usr_admin_id: key,
                }
            }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    UsrAdminsListCtl.prototype.GetAdminPassword = function (key, onDone) {
        var _this = this;
        webAApi_1.DoGetAdminPassword.exec({ data: { admin_id: key } }, function (resp) {
            if (onDone) {
                onDone(resp.password);
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    UsrAdminsListCtl.prototype.GenerateAdminPassword = function (onDone) {
        var _this = this;
        webAApi_1.DoGenerateAdminPassword.exec({}, function (resp) {
            if (onDone) {
                onDone(resp.password);
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    UsrAdminsListCtl.prototype.SetAdminIsLocked = function (key, IsLocked, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetAdminIsLocked.exec({ data: { admin_id: key, is_locked: IsLocked } }, function (resp) {
                _tmp.is_locked = IsLocked;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    UsrAdminsListCtl.prototype.SetAdminNewPassword = function (key, newPassword, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetAdminNewPassword.exec({ data: { admin_id: key, new_password: newPassword } }, function (resp) {
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return UsrAdminsListCtl;
}(BaseController_1.BaseController));
exports.UsrAdminsListCtl = UsrAdminsListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/usr_admins_list/ctl/UsrAdminsListCtl.ts
// module id = 861
// module chunks = 0